import { QueryFormatFilter } from '@hotjar/global-filters';
import { getRecordingId } from '@hotjar/webapp/features/Playbacks/store/utils';
import { SEARCH_CONTEXT_STORAGE_KEY, RECORDING_ID_STORAGE_KEY } from './constants';
import { DEFAULT_HOTJAR_FILTERS } from '../../../../constants/hotjar-filters';
import { HotjarFilters } from '../../../list/types';
import { getOneYearAgoDateRangeTimestamps } from '../../../../utils/generateRequestFilters';

import type { PartialRecording } from '../../types';

type Context = {
  jsonFilters: QueryFormatFilter;
  hotjarFilters?: HotjarFilters;
  sortBy: string;
  recordingsRequestTimeRange: number[];
  rootRecording?: PartialRecording;
  customPlaylistTitle?: string;
};

export const getRecordingsSearchContext = (): Context => {
  const localStorageContext = localStorage.getItem(SEARCH_CONTEXT_STORAGE_KEY);

  if (localStorageContext) {
    localStorage.removeItem(SEARCH_CONTEXT_STORAGE_KEY);
    sessionStorage.setItem(SEARCH_CONTEXT_STORAGE_KEY, localStorageContext);

    return JSON.parse(localStorageContext) as Context;
  }

  const sessionStorageContext = sessionStorage.getItem(SEARCH_CONTEXT_STORAGE_KEY);
  const storedRecordingId = sessionStorage.getItem(RECORDING_ID_STORAGE_KEY) || '';

  // Prevent loading stale state after user manually navigates to another recording
  if (sessionStorageContext && parseInt(storedRecordingId) === getRecordingId()) {
    return JSON.parse(sessionStorageContext) as Context;
  }

  const defaultContext = {
    jsonFilters: { AND: [{ DAYS_AGO: { created: 365 } }] },
    hotjarFilters: { ...DEFAULT_HOTJAR_FILTERS },
    sortBy: '-relevance_score',
    recordingsRequestTimeRange: getOneYearAgoDateRangeTimestamps(),
    rootRecording: { id: getRecordingId() },
  };

  sessionStorage.setItem(SEARCH_CONTEXT_STORAGE_KEY, JSON.stringify(defaultContext));
  return defaultContext;
};
